import styled from 'styled-components'
import Img from '../../../shared/Image'

export const Logo = styled(Img)`
  display: ${props => props.display};
  float: left;
  height: 28px;
  width: auto;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    height: 40px;
  }
`

export const CountrySelectContainer = styled.div`
  position: relative;
  color: ${props =>
    props.lighttheme ? props.theme.colors.white : props.theme.colors.black};
  display: none;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: block;
    margin-left: auto;
    padding-top: 0;
  }

  svg {
    width: 11px;
    height: 8px;
    display: inline-block;
    position: absolute;
    top: 0.7rem;
    right: 0;
    z-index: -1;
  }
`

export const CountrySelector = styled.select`
  display: inline-block;
  appearance: none;
  color: inherit;
  font-size: 1.4rem;
  background: transparent;
  border: 0;

  option {
    color: ${props => props.theme.colors.black};
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    padding-right: 2rem;
  }
`

export const Header = styled.header`
  position: fixed;
  top: ${props => (props.sticky ? '0' : '1rem')};
  background: ${props =>
    props.sticky ? props.theme.colors.white : 'transparent'};
  width: 100%;
  padding: 1.4rem 2rem;
  z-index: 30;
  box-shadow: ${props =>
    props.sticky ? '0 4px 4px 0 rgba(0, 0, 0, 0.1)' : 'none'};
  transition: background 300ms ease-out;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    top: ${props => (props.sticky ? '0' : '2rem')};
    padding: 1rem 3.5rem;
  }

  .sticky-navitem {
    a,
    span {
      color: ${props => props.theme.colors.black};
    }

    ${CountrySelectContainer} {
      color: ${props => props.theme.colors.black};
    }
  }
`
export const Nav = styled.nav`
  width: 100%;
  font-size: 1.4rem;
`

export const NavLinks = styled.div`
  display: none;
  justify-content: center;
  padding-top: 0.75rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: flex;
  }
`

export const MobileMenu = styled.div`
  position: fixed;
  background: ${props => props.theme.colors.black};
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 300;
  padding: 9rem 2rem 6rem;
  visibility: visible;
  transform: ${props =>
    props.menuOpen ? 'translate3d(0, 0, 0)' : 'translate3d(100%, 0, 0)'};
  transition: all 0.5s;
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: none;
  }

  ${CountrySelectContainer} {
    position: absolute;
    bottom: 5rem;
    display: block;
    width: calc(100% - 4rem);
    border-top: 2px solid ${props => props.theme.colors.white};
    border-radius: 0;
    color: ${props => props.theme.colors.white};

    svg {
      width: 14px;
      height: 12px;
      top: 2.9rem;
    }

    ${CountrySelector} {
      width: 100%;
      padding-top: 2.6rem;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      bottom: 3rem;
    }
  }
`

export const HamburgerMenu = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
  z-index: 302;
  float: right;
  margin-top: 0.7rem;

  span {
    display: block;
    position: absolute;
    height: ${props => (props.menuOpen ? '0.2rem' : '0.1rem')};
    width: 100%;
    /* Essentially: checks if the burger menu is open, then it will be white. If it's sticky, then it will always be dark, otherwise checks on light theme  */
    background: ${props =>
    props.menuOpen
      ? props.theme.colors.white
      : props =>
        props.sticky
          ? props.theme.colors.black
          : props =>
            props.lighttheme
              ? props.theme.colors.white
              : props.theme.colors.black};
    border-radius: 0.9rem;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.3s ease-in-out;

    &:nth-child(1) {
      top: ${props => (props.menuOpen ? '1.8rem' : '0')};
      width: ${props => (props.menuOpen ? '0%' : '100%')};
      left: ${props => (props.menuOpen ? '50%' : '0')};
    }

    &:nth-child(2),
    &:nth-child(3) {
      top: 0.6rem;
    }

    &:nth-child(2) {
      transform: rotate(${props => (props.menuOpen ? '45deg' : '0deg')});
    }

    &:nth-child(3) {
      transform: rotate(${props => (props.menuOpen ? '-45deg' : '0deg')});
    }

    &:nth-child(4) {
      top: ${props => (props.menuOpen ? '1.8rem' : '1.2rem')};
      width: ${props => (props.menuOpen ? '0%' : '100%')};
      left: ${props => (props.menuOpen ? '50%' : '0')};
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: none;
  }
`
